import type { TrackedTranslation } from '@ps/web-core-intl';
import type { InputProps } from '@ps/web-shared-components';
import { email } from '@ps/web-shared-validators';
import React from 'react';

import TextInput from '../TextInput/TextInput';

import { TXTCLI_Email } from './Email.messages.json';

interface Props extends Omit<InputProps, 'label'> {
  label?: TrackedTranslation;
}

const Email: React.FC<Props> = ({ validators, label = TXTCLI_Email, ...rest }) => (
  <TextInput
    autoComplete="off"
    validators={[email, ...(validators || [])]}
    label={label}
    {...rest}
  />
);

export default Email;
